// Unified conversation types for multi-channel inbox
export type ChannelType = 'sms' | 'facebook' | 'instagram' | 'gmail' | 'whatsapp' | 'web_chat';

export interface Participant {
  id: string;
  name: string;
  role: 'user' | 'ai' | 'support';
  avatar?: string;
  email?: string;
  phone?: string;
}

export interface Attachment {
  type: 'image' | 'video' | 'file' | 'audio';
  url: string;
  name?: string;
  size?: number;
  thumbnail?: string;
}

export interface Reaction {
  emoji: string;
  userId: string;
  timestamp: Date;
}

export interface Message {
  id: string;
  conversationId: string;
  participantId: string;
  content: string;
  timestamp: Date;
  isRead: boolean;
  attachments?: Attachment[];
  reactions?: Reaction[];
  metadata?: Record<string, any>;
}

export interface Conversation {
  id: string;
  title: string;
  participants: Participant[];
  messages: Message[];
  lastActivity: Date;
  isArchived: boolean;
  unread?: boolean;
  lastMessage?: string;
  lastMessageAt?: Date;
  channel: ChannelType;
  channelId?: string;
  metadata?: Record<string, any>;
}

export interface ChannelInfo {
  type: ChannelType;
  label: string;
  icon: string;
  color: string;
  bgColor: string;
}

export const CHANNEL_INFO: Record<ChannelType, ChannelInfo> = {
  sms: {
    type: 'sms',
    label: 'SMS',
    icon: 'MessageSquare',
    color: '#10b981',
    bgColor: '#10b981'
  },
  facebook: {
    type: 'facebook',
    label: 'Messenger',
    icon: 'Facebook',
    color: '#0084ff',
    bgColor: '#0084ff'
  },
  instagram: {
    type: 'instagram',
    label: 'Instagram',
    icon: 'Instagram',
    color: '#E4405F',
    bgColor: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)'
  },
  gmail: {
    type: 'gmail',
    label: 'Email',
    icon: 'Mail',
    color: '#EA4335',
    bgColor: '#EA4335'
  },
  whatsapp: {
    type: 'whatsapp',
    label: 'WhatsApp',
    icon: 'MessageCircle',
    color: '#25D366',
    bgColor: '#25D366'
  },
  web_chat: {
    type: 'web_chat',
    label: 'Web Chat',
    icon: 'Globe',
    color: '#6366f1',
    bgColor: '#6366f1'
  }
};